import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { getCachedStoreInfo } from '../../services/storeApi';
import { BrandMark } from './BrandLogo';

export function StoreWelcome() {
  const { user } = useAuth();
  const cachedStore = getCachedStoreInfo();
  const storeName =
    user?.attributes?.['custom:store_name']?.trim() || cachedStore?.storeName?.trim();
  const storeCode =
    user?.attributes?.['custom:device_id']?.trim() || cachedStore?.deviceId?.trim();

  if (!storeName) {
    return (
      <Link to="/provider/" className="provider-store-welcome provider-store-welcome--fallback">
        <BrandMark size="sm" />
        <span className="provider-store-welcome-text">
          <span className="provider-store-welcome-eyebrow">Provider portal</span>
          <span className="provider-store-welcome-name">My account</span>
        </span>
      </Link>
    );
  }

  return (
    <Link to="/provider/" className="provider-store-welcome" aria-label={`Welcome to ${storeName}`}>
      <span className="provider-store-welcome-mark" aria-hidden="true">
        <BrandMark size="sm" />
      </span>
      <span className="provider-store-welcome-text">
        <span className="provider-store-welcome-name">{storeName}</span>
        {storeCode && <span className="provider-store-welcome-meta">Store {storeCode}</span>}
      </span>
    </Link>
  );
}

export default StoreWelcome;
